const Raven = require('Raven');

/**
 * Log a message to Sentry
 * @param  {string} message The message to log
 * @return {undefined}
 */
export function logErrorMessage(message:string):void {
	if (!__DEV__) {
		Raven.captureMessage(message);
	} else {
		// do not use console.error because raven log that too
		console.log('log raven err mess in dev', message); // eslint-disable-line no-console
	}
}

export function logException(err):void {
	if (!__DEV__) {
		Raven.captureException(err);
	} else {
		// do not use console.error because raven log that too
		console.log('log raven ex in dev', JSON.stringify(err)); // eslint-disable-line no-console
	}
}



/** WEBPACK FOOTER **
 ** ./Scripts/libs/utils/log/logError.js
 **/